export default {
  path: "/app/document-in",
  name: "document-in",
  redirect: "/app/document-in/list",
  component: () => import("./layout"),
  children: [
    {
      path: "list",
      name: "listDocumentIn",
      component: () =>
        import("./components/listDocument/list-document-in.created-by-me"),
      meta: {
        appName: "listDocumentIn",
      },
    },
    {
      path: "list-wait-process",
      name: "listDocumentInWaitProcess",
      component: () =>
        import("./components/listDocument/list-document-in.wait-process"),
      meta: {
        appName: "listDocumentInWaitProcess",
      },
    },
    {
      path: "list-wait-approval",
      name: "listDocumentInWaitApproval",
      component: () =>
        import("./components/listDocument/list-document-in.wait-approval"),
      meta: {
        appName: "listDocumentInWaitApproval",
      },
    },
    {
      path: "list-has-approved",
      name: "listDocumentInHasApproved",
      component: () =>
        import("./components/listDocument/list-document-in.has-approval"),
      meta: {
        appName: "listDocumentInHasApproved",
      },
    },
    {
      path: "list-approved",
      name: "listDocumentInApproved",
      component: () =>
        import("./components/listDocument/list-document-in.approved"),
      meta: {
        appName: "listDocumentInApproved",
      },
    },
    {
      path: "list-department-manager",
      name: "listDocumentInDepartmentManager",
      component: () =>
        import("./components/listDocument/list-document-in.department-manager"),
      meta: {
        appName: "listDocumentInDepartmentManager",
      },
    },
    {
      path: "list-all-document",
      name: "listAllDocumentIn",
      component: () =>
        import("./components/listDocument/list-document-in.all-document"),
      meta: {
        appName: "listAllDocumentIn",
      },
    },
    {
      path: "list-all-document/export",
      name: "listAllDocumentInExport",
      component: () =>
        import(
          "./components/listDocument/list-document-in.all-document.export"
        ),
    },

    {
      path: "detail/:idDocument",
      name: "detailDocumentIn",
      component: () =>
        import("./components/detail-view/document-in.detail-page"),
    },
    {
      path: "detail-process/:idDocument",
      name: "detailProcessDocumentIn",
      component: () =>
        import("./components/detail-view/document-in.detail-process"),
    },
    {
      path: "r/:idDocument",
      name: "redirectDocumentIn",
      component: () => import("./document-in.redirect-view"),
    },
    {
      path: "detail-approval/:idDocument",
      name: "detailApprovalDocumentIn",
      component: () =>
        import("./components/detail-view/document-in.detail-approval"),
    },

    {
      path: "update/:idDocument",
      name: "updateDocumentIn",
      component: () => import("./document-in.update-page"),
    },
    {
      path: "add",
      name: "addDocumentIn",
      component: () => import("./document-in.add-page"),
    },
  ],
};
